import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { trigger, transition, style, animate, query, stagger } from '@angular/animations'
import { AppService } from 'src/app/server/app.service'
import { AuthService } from 'src/app/shared/security/auth.service'
import { Subscription } from 'rxjs'
import * as io from 'socket.io-client'

// import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'flow-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [ // each time the binding value changes
        query(':leave', [
          stagger(100, [
            animate('1.0s', style({ opacity: 0 }))
          ])
        ], { optional: true }),
        query(':enter', [
          style({ opacity: 0 }),
          stagger(100, [
            animate('2.0s', style({ opacity: 1 }))
          ])
        ], { optional: true })
      ])
    ])
  ]
})

export class HomeComponent implements OnInit {

  subscriptions: Array<Subscription> = []
  menuItem = []
  themeid = 1

  @ViewChild("game")
  private gameCanvas: ElementRef
  private context: any
  private socket: any

  constructor(
    private appService: AppService,
    private auth: AuthService
  ) {

    this.socket = io("http://13.82.143.251:3031")

    this.socket.on("position",
      data => {
        //this.context.clearRect(0, 0, this.gameCanvas.nativeElement.width, this.gameCanvas.nativeElement.height);
        //this.context.fillRect(data.x, data.y, 20, 20);
        console.log(data)
      }
    );

    // this.socket.on("progress",
    //   data => {
    //     console.log(data)
    //     this.appService.progressTax = data
    //     this.appService.eventProgress.emit(data)
    //   }
    // );
  }

  ngOnInit() {

    this.appService.setTitle(`Home`)

    this.subscriptions.push(
      this.appService.eventSession.subscribe(
        session => {
          this.themeid = session.themeid
        }
      )
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe()
    })
  }

  ngAfterViewInit() {

    //this.context = this.gameCanvas.nativeElement.getContext("2d");

    this.appService.eventOpenDetail.emit(false)
    this.appService.getUserMenu(0).subscribe(
      items => {
        //console.log(items)
        this.menuItem = items //user[0].menu
      }
    )

  }

  logAnimation(_event) {

  }

  move(direction: string) {
    this.socket.emit("move", direction);
  }


}
